module.exports = __webpack_public_path__ + "static/media/mis_pagos.bc0e28a3.svg";